import {
    ChangeDetectionStrategy,
    Component,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { IEmailMessageHistory } from '@dxp/core/models';
import { SortPipe, UnsafePipe } from '@dxp/core/pipes';

@Component({
    selector: 'telxl-shared-email-history',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SortPipe, UnsafePipe],
    templateUrl: './email-history.component.html',
    styleUrl: './email-history.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class TelXLEmailHistoryComponent {
    messages = input.required<IEmailMessageHistory[]>();

    messageBody(message: IEmailMessageHistory): string {
        return message.body?.content ?? '';
    }

    messageFrom(message: IEmailMessageHistory): string {
        return message.from.address;
    }

    messageTo(message: IEmailMessageHistory): string {
        return message.toRecipients.map(to => to.address).join(', ');
    }
}
